import React from 'react';
import fr from 'facet-rest';
import SecurityProfileSubpageRevamp from './SecurityProfileSubpageRevamp';
import SecurityProfileSubpage from './SecurityProfileSubpage';

export const SecurityProfileSubpagePicker = ({ resource }) => {
  return resource.withRelationship(fr.relationships.userSettingsSecurityPageRevamp.name,
    (_) => <SecurityProfileSubpageRevamp resource={resource} />,
    () => <SecurityProfileSubpage resource={resource} />);
};
